//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";

export const LetterAndDocument = createAsyncThunk(
  "LetterAndDocument",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingGetLetterAndDocument(""));
      const response = await UsePortalApi(
        `Patient/LetterAndDocument`,
        "Post",
        payload,
        true
      );
      if (response) {
        console.log(response , "response")
        response[0].hasOwnProperty('entry') ? dispatch(gettingGetLetterAndDocumentSuccess(response[0].entry)) : dispatch(gettingGetLetterAndDocumentClear())

      } else {
        dispatch(
          gettingGetLetterAndDocumentFailed(
            response?.errorMessage
          )
        );
      }
    } catch (error) {
      dispatch(gettingGetLetterAndDocumentFailed(error));
    }
  }
);

const GetLetterAndDocumentSlice = createSlice({
  name: "LetterAndDocument",
  initialState: {
    Letters: null,
    isGettingLetters: false,
    error: false,
  },
  reducers: {
    gettingGetLetterAndDocument: (state, action) => {
      state.Letters = null;
      state.isGettingLetters = true;
      state.error = false;
    },
    gettingGetLetterAndDocumentSuccess: (state, action) => {
      state.Letters = action.payload;
      state.isGettingLetters = false;
      state.error = false;
    },
    gettingGetLetterAndDocumentFailed: (state, action) => {
      state.Letters = null;
      state.isGettingLetters = false;
      state.error = true;
    },
    gettingGetLetterAndDocumentClear: (state, action) => {
      state.Letters = null;
      state.isGettingLetters = false;
      state.error = false;
    },
  },
});
export const {
  gettingGetLetterAndDocument,
  gettingGetLetterAndDocumentSuccess,
  gettingGetLetterAndDocumentFailed,
  gettingGetLetterAndDocumentClear,
} = GetLetterAndDocumentSlice.actions;
export default GetLetterAndDocumentSlice.reducer;
